module.exports = __webpack_public_path__ + "static/media/Triangle Area.38cef8ce.jpg";